const url = {
  login: '/auth/login',
  exam: {
    getAllExams: 'exam/getAllExam',
    crateExam: 'exam/createExam',
    deleteOneExam: 'exam/deleteOneExam',
    updateExam: '/exam/updateExam',
    getExamById: '/exam/getExamById',
    getExamStatus: '/exam/getExamStatuses',
    updateExamStatus: '/exam/updateExamStatus',
    uploadCandidateData: '/examMapping/uploadUserCsvData',
    uploadZipUserData: "/examMapping/uploadZipUserData",
    getAllMappedUser: '/examMapping/getAllMappedUser',
    deleteMappingForExam: '/examMapping/deleteExamMappingForExam',
    getExamLanguage: '/exam/getExamLanguages',
    setExamDateAndTime: '/exam/updateExamTime',
    setuserAllowedTillTime: '/exam/updateUserTillTime',
    setUserAllowedTime: '/exam/updateUserAllowedExamTime',
    getUserAllowedExamTime: '/exam/getUserAllowedExamTime',
    markExamCompleted: '/exam/markAsCompleted',
    getAllUsers: '/exam/getAllExamStudents', 
    getExamLayout: "/exam/getExamLayout",
    getQuestionData:'/admin/getQuestionData'
  },
  admin: {
    getQuestionsByExamId: 'admin/getQuestionsByExamId',
    getQuestionById: 'admin/getQuestionById',
    addQuestionToExam: 'admin/addQuestionToExam',
    addAnswerToQuestion: 'admin/addAnswerToQuestion',
    addQuestionToQuestionById: 'admin/addQuestionToQuestion',
    makeExamive: '/admin/makeExamLive',
    getExamsections: '/admin/getExamSections',
    addOptionToQuestion: '/admin/addOptionToQuestion',
    deleteQuestionFromQuestionId: '/admin/deleteQuestionFromQuestionById',
    userAllowedStartTime: '/exam/userAllowedStartTime',
    getQuestionDataByExamIdAndSectionId:
      '/exam/getExamQuestionsByExamIdSectionId',
    deleteQuestionById: '/admin/deleteQuestionById',
    deleteOptionById: '/admin/deleteOptionById',
    deleteQuestionFromQuestion: '/admin/deleteQuestionFromQuestionById',
    getAllResponsesByExamId: '/admin/getAllResponsesByExamId',
    deleteStatementById: '/admin/deleteStatementById',
    getUserResponseByMappingId: '/admin/getUserResponseByMappingId',
    getAllCompletedUsersForExam: '/admin/getAllCompletedUsersForExam',
    getS3Link: "/admin/getS3Link",
    getDecriptionKeys: "/admin/getDecriptionKeys",
    setTimeMapping: '/admin/addChangeMappingTime',
    toggleUserActive: '/admin/toggleUserActive',
    resetMappingTime: "/admin/resetMappingTime",
    deleteQuestionDicomByQuestionDataId: "/admin/deleteQuestionDicomByQuestionDataId",
    deleteQuestionImageByQuestionDataId: "/admin/deleteQuestionImageByQuestionDataId",
    deleteQuestionDataAsImage: "/admin/deleteQuestionAsImage",
    duplicateQuestion: "/admin/duplicateQuestion",
    questionMoveQuestionId: "/admin/question/move",
    user_logs: "/admin/user/logs",
    user_logs_pdf: "/admin/log/create/pdf"
  },
  user: {
    getAllUsers: '/admin/getAllUser',
    resetPasswordForUser: '/user/resetPasswordForUser',
    deleteStudentMapping: '/examMapping/deleteStudentMapping',
    disableStudentMapping: '/examMapping/disableStudentMapping',
    toggleStudentMapping: '/examMapping/toggleStudentMapping',
    unMarkCompletedMapping: '/examMapping/unMarkCompletedMapping',
  },
  logs: {
    getAllLogs: '/log/getAllLogs',
    getAllLogsByMappingId: "/log/getAllLogsByMappingId",
  },
  pulic: {
    getQuestionType: '/public/getQuestionTypes',
    getOptionType: '/public/getOptionTypes',
    getQuestionDataTypes: '/public/getQuestionDataTypes',
    getAllLanguages: '/public/getAllLanguages',
  },
  result: {
    getResultResponse: "/result/getResponses",
    getEncryptedOptionById: "/result/getencryptedOptionsById",
    createUserResultCSVByExamId: "/result/createUserResultCSVByExamId",
    ans_mark: "/answer/result/mark",
    getQuestionAnswersByExamId: "/answer/result/getQuestionAnswers",
    generateResult: "/answer/result/create",
    createUserResult: "/result/createUserResult",
    downloadExistingResultZip: "/result/downloadExistingResultZip",
  },

  client : {
    createClient: "/client/create",
    getAllClient:"/client/get",
    updateClientPassword: "/client/update/password",
    deleteClient: "/client/delete",
  },

  centerAdmin: {
    create: '/admin/center-admin/create',
    update: '/admin/center-admin/update',
    getAll: '/admin/center-admin/get',
    toggleSuspend:"/admin/center-admin/toggle-disable",
    resetPassword:"/admin/center-admin/reset-password"
  },

  getAllExamCities:"/examMapping/cities"
};

export default url;
